import { z } from 'zod';
export const BaseEventMetadataSchema = z.object({
    timestamp: z.string(),
    transactionId: z.string(),
    eventType: z.enum(['assignment', 'note', 'status', 'customDocument', 'estimate']),
});
export const ParsedExportBaseSchema = BaseEventMetadataSchema.merge(z.object({
    eventId: z.string(),
}));
